import { Subject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';
@Injectable({
  providedIn: 'root'
})
export class UserService {

  private liveEventsSubject = new Subject<any>();
  private userSubSubject = new Subject<any>();
  private chatMessageSubject = new Subject<any>();
  isLiveEventSubject = new Subject<any>();
  private isVideoChannelConnectedSubject = new Subject<any>();
  private OrgInfoSubject = new Subject<any>();
  liveEvents: any = {};
  userSub: any;
  isSubscribedSubject = new Subject<any>();
  streamMeticsSubject = new Subject<any>();
  showActiveStreamBlock = new Subject<any>();
  showActiveReaction = new Subject<any>();
  showEmojiList = new Subject<any>();
  sendEmojiReaction = new Subject<any>();
  streamDetailsendToStreamHeader = new Subject<any>();
  streamStatusSubject = new Subject<any>();
  pollDataSubject = new Subject<any>();
  isChatEnabledSubject = new Subject<any>();
  messageStatusSubject = new Subject<any>();
  isPaymentEnabledSubject = new Subject<boolean>();
  ChatStatusSubject = new Subject<any>();
  streamPlayerStatusSubject = new Subject<any>();
  activeStreamChannel = new Subject<any>();
  contactStatusSubject = new Subject<any>();
  iscanSelectChannel = new Subject<any>();

  ticketStatus = new Subject<any>();

  constructor() { }

  sendLiveEvents(data: any) {
    if (data && data.data && data.data.Data) {
      this.liveEvents = data.data.Data;
    }
    // if(data && data.stream_info){
    //   this.liveEvents = data;
    // }
    this.liveEventsSubject.next(data);
  }
  getLiveEvents(): Observable<any> {
    return this.liveEventsSubject.asObservable();
  }
  sendUserSub(data: any) {

    this.userSub = data;
    // if(data && data.stream_info){
    //   this.liveEvents = data;
    // }
    this.userSubSubject.next(data);
  }
  getUserSub(): Observable<any> {
    return this.userSubSubject.asObservable();
  }
  getStreamMetics(): Observable<any> {
    return this.streamMeticsSubject.asObservable();
  }

  sendChatMessage(data: any) {
    this.chatMessageSubject.next(data);
  }
  getChatMessage(): Observable<any> {
    return this.chatMessageSubject.asObservable();
  }

  sendStreamStatus(data: any) {
    this.streamStatusSubject.next(data);
  }
  getStreamStatus(): Observable<any> {
    return this.streamStatusSubject.asObservable();
  }

  sendContactStatus(data: any) {
    this.contactStatusSubject.next(data);
  }
  getContactStatus(): Observable<any> {
    return this.contactStatusSubject.asObservable();
  }

  sendStatus(data: any) {
    this.ChatStatusSubject.next(data);
  }
  getStatus(): Observable<any> {
    return this.ChatStatusSubject.asObservable();
  }

  sendPollData(data: any) {
    this.pollDataSubject.next(data);
  }
  getPollData(): Observable<any> {
    return this.pollDataSubject.asObservable();
  }

  sendIsLiveEventSubject(data: any) {
    this.isLiveEventSubject.next(data);
  }
  getIsLiveEventSubject(): Observable<any> {
    return this.isLiveEventSubject.asObservable();
  }

  sendIsVideoChannelConnectedSubject(data: any) {
    this.isVideoChannelConnectedSubject.next(data);
  }
  getIsVideoChannelConnectedSubject(): Observable<any> {
    return this.isVideoChannelConnectedSubject.asObservable();
  }

  sendOrgInfo(data: any) {
    this.OrgInfoSubject.next(data);
  }
  getOrgInfo(): Observable<any> {
    return this.OrgInfoSubject.asObservable();
  }
  getIsSubscribed(): Observable<any> {
    return this.isSubscribedSubject.asObservable();
  }
  sendIsSubscribed(data: any) {
    this.isSubscribedSubject.next(data);
  }

  getShowActiveStreamBlock(): Observable<any> {
    return this.showActiveStreamBlock.asObservable();
  }
  getShowActiveSReaction(): Observable<any> {
    return this.showActiveReaction.asObservable();
  }
  getReactionBlock(): Observable<any> {
    return this.showEmojiList.asObservable();
  }

  getsentEmojiReaction(): Observable<any> {
    return this.sendEmojiReaction.asObservable();
  }

  getsetStreamDetailToStreamHeader(): Observable<any> {
    return this.streamDetailsendToStreamHeader.asObservable();
  }

  sendIsChatEnabledSubject(data: any) {
    this.isChatEnabledSubject.next(data);
  }
  getIsChatEnabledSubject(): Observable<any> {
    return this.isLiveEventSubject.asObservable();
  }

  sendMessageStatus(data: any) {
    this.messageStatusSubject.next(data);
  }
  getMessageStatus(): Observable<any> {
    return this.messageStatusSubject.asObservable();
  }

  sendPlayerStatus(data: any) {
    this.streamPlayerStatusSubject.next(data);
  }
  getPlayerStatus(): Observable<any> {
    return this.streamPlayerStatusSubject.asObservable();
  }

  getActiveStreamChannel(): Observable<any> {
    return this.activeStreamChannel.asObservable();
  }

  getIscanSelectChannel(): Observable<any> {
    return this.iscanSelectChannel.asObservable();
  }

  setTicketStatus(data: any) {
    this.ticketStatus.next(data);
  }
  getTicketStatus(): Observable<any> {
    return this.ticketStatus.asObservable();
  }

  getTimezone() {
    return moment.tz.guess();
  }

}
